/**
 * Fold an open contact-list edit and any Add drafts into the saved rows.
 * An empty Add draft is dropped. A draft or edit with a validation error blocks save.
 */
export function commitContactRows({
  rows = [],
  editingIndex = null,
  editValues = null,
  drafts = [],
  isDraftEmpty,
  validate,
  normalizeEntry,
}) {
  const editErrors =
    editingIndex === null ? null : validate?.(editValues) ?? {};
  if (editErrors && Object.keys(editErrors).length > 0) {
    return { ok: false, editErrors, draftErrors: {} };
  }

  const draftErrors = {};
  const draftEntries = [];
  for (const draft of drafts) {
    if (isDraftEmpty?.(draft.values)) continue;
    const errors = validate?.(draft.values) ?? {};
    if (Object.keys(errors).length > 0) {
      draftErrors[draft.id] = errors;
      continue;
    }
    draftEntries.push(normalizeEntry(draft.values));
  }
  if (Object.keys(draftErrors).length > 0) {
    return { ok: false, editErrors: null, draftErrors };
  }

  const changed = editingIndex !== null || draftEntries.length > 0;
  if (!changed) return { ok: true, changed: false };

  const next = [...rows];
  if (editingIndex !== null) {
    next[editingIndex] = normalizeEntry(editValues, rows[editingIndex]);
  }
  return {
    ok: true,
    changed: true,
    rows: [...draftEntries.reverse(), ...next],
  };
}
